import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureMediaProjectByIdQueryData } from '@/api/media';
import { requireMediaWrite } from '@/features/permissions/route-permissions';
import { getProject } from '@/features/projects/api/projects';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/'
)({
  loader: async (props) => {
    const project = await getProject(props.params.projectId);

    requireMediaWrite(project.metadata?.permissions, {
      type: 'project',
      projectId: props.params.projectId,
    });

    try {
      return await ensureMediaProjectByIdQueryData(props);
    } catch {
      throw redirect({
        to: '/projects/$projectId/media',
        params: { projectId: props.params.projectId },
      });
    }
  },
});
